import { Controller } from '@hotwired/stimulus';

let lightThemeName = 'light';
let darkThemeName = 'dark';

if (
  localStorage.getItem('theme') === 'dark' ||
  (!('theme' in localStorage) &&
    window.matchMedia('(prefers-color-scheme: dark)').matches)
) {
  document.documentElement.setAttribute('data-theme', darkThemeName);
} else {
  document.documentElement.setAttribute('data-theme', lightThemeName);
}

// Connects to data-controller="theme"
export default class extends Controller {
  static targets = ['lightIcon', 'darkIcon'];

  connect() {
    if (localStorage.theme === 'dark') {
      this.darkIconTarget.classList.toggle('hidden');
    } else {
      this.lightIconTarget.classList.toggle('hidden');
    }
  }

  toggle() {
    if (localStorage.theme === 'dark') {
      // our new theme is light
      localStorage.theme = 'light';
      document.documentElement.setAttribute('data-theme', lightThemeName);
      this.lightIconTarget.classList.toggle('hidden');
      this.darkIconTarget.classList.toggle('hidden');
    } else {
      // our new theme is dark
      localStorage.theme = 'dark';
      document.documentElement.setAttribute('data-theme', darkThemeName);
      this.darkIconTarget.classList.toggle('hidden');
      this.lightIconTarget.classList.toggle('hidden');
    }
  }
}
